import React from 'react';

import DividerContainer from './DividerContainer';
import DividerHorizontal from './DividerHorizontal';
import DividerVertical from './DividerVertical';
import { DividerProps } from './types';

const dividersByOrientation = {
  horizontal: DividerHorizontal,
  vertical: DividerVertical,
};

const Divider = ({
  orientation,
  type = 'solid',
  ...baseDividerProps
}: DividerProps) => {
  const DividerComponent = dividersByOrientation[orientation];

  return (
    <DividerContainer orientation={orientation}>
      <DividerComponent type={type} {...baseDividerProps} />
    </DividerContainer>
  );
};

export default Divider;
